import { Container, Row, Col } from '@ui/wrapper'
import TeamMember from '@components/team-member'
import { SectionWrapper, StyledContent } from './style'

const BeiratArea = ({ data, ...rest }) => {
  return (
    <SectionWrapper {...rest}>
      <Container>
        <StyledContent>
          <Row gutters={{ lg: 60 }}>
            {data?.items?.map((member) => (
              <Col
                md={4}
                key={member.id}
                mb="30px"
                style={{
                  paddingLeft: '50px',
                  paddingRight: '50px',
                  paddingBottom: '10px'
                }}
              >
                <TeamMember
                  layout={2}
                  image={member.images?.[0]}
                  name={member.name}
                  designation={member.designation}
                  socials={member.socials}
                />
              </Col>
            ))}
          </Row>
        </StyledContent>
      </Container>
    </SectionWrapper>
  )
}

export default BeiratArea
